import s from"styled-components";import{theme as r}from"../../../theme.js";const e=s.div`
  border: 4px solid ${({status:o})=>o?r.colors.success[500]:r.colors.error[500]};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  > svg {
    width: 40px;
    height: 40px;
    > g, path {
      fill: ${({status:o})=>o?r.colors.success[500]:r.colors.error[500]};
    }
  }
`;export{e as Container};
